import { HOVER_ANIMATION_DURATION } from "./CategoryShowcaseConstants";

export const containerStyles = {
  position: "relative",
  overflow: "hidden",
  height: "100%",
  cursor: 'pointer'
};

export const imageStyles = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  cursor: "pointer",
  transition: "transform 0.6s ease, filter 0.6s ease",
};

export const textContainerStyles = {
  position: "absolute",
  bottom: 20,
  left: 16,
  color: "white",
  zIndex: 2,
  width: '100%'
};

export const titleContainerStyles = {
  position: "absolute",
  bottom: "50px",
  left: 0,
  transition: "transform 0.5s ease",
  width: '100%'
};

export const titleTextStyles = {
  fontFamily: "inherit",
  fontWeight: 700,
  variant: "h2",
  fontSize: "2.5rem",
  whiteSpace: "normal",
  overflow: "visible",
  wordBreak: "break-word",
  lineHeight: 1.2,
  maxWidth: "90%",
};
export const subtitleContainerStyles = {
  position: "absolute",
  bottom: "30px",
  left: 0,
  transition: `opacity ${HOVER_ANIMATION_DURATION}s ease`,
};

export const subtitleWrapperStyles = {
  position: "relative",
  display: "inline-block",
};

export const subtitleTextStyles = {
  fontFamily: "inherit",
  fontWeight: 400,
  variant: "h3",
  fontSize: "1.4rem",
  letterSpacing: "3px",
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
  paddingBottom: "5px",
  color: 'white !important',
  margin: 0,
};

export const underlineStyles = {
  position: "absolute",
  bottom: 0,
  left: 0,
  width: "100%",
  height: "1px",
  backgroundColor: "white",
  transition: `opacity ${HOVER_ANIMATION_DURATION}s ease`,
};

export const showcaseContainerStyles = {
  display: "flex",
  height: 884,
  '@media (max-width: 768px)': {
    flexDirection: "column",
    height: "auto",
  },
};

export const leftHalfStyles = {
  width: "50%",
  height: "100%",
  '@media (max-width: 768px)': {
    width: "100%",
    height: "869px",
    order: 1,
  },
};

export const rightHalfStyles = {
  width: "50%",
  height: "100%",
  display: "flex",
  flexDirection: "column",
  '@media (max-width: 768px)': {
    width: "100%",
    height: "auto",
    order: 2,
  },
};

export const topHalfStyles = {
  width: "100%",
  height: "50%",
  '@media (max-width: 768px)': {
    height: "434.5px",
  },
};

export const bottomHalfStyles = {
  width: "100%",
  height: "50%",
  display: "flex",
  '@media (max-width: 768px)': {
    flexDirection: "column",
    height: "auto",
  },
};

export const bottomLeftStyles = {
  width: "50%",
  height: "100%",
  '@media (max-width: 768px)': {
    width: "100%",
    height: "434.5px",
  },
};

export const bottomRightStyles = {
  width: "50%",
  height: "100%",
  '@media (max-width: 768px)': {
    width: "100%",
    height: "434.5px",
  },
};














